var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "social-group", class: _vm.brandingClass },
    [
      _c("content-creator", {
        attrs: {
          settings: _vm.getBlobContents("footer-social-icons"),
          permissions: _vm.contentCreatorPermissions,
          "is-visible": _vm.editContentCreator,
          filestore: _vm.fileStore,
          name: "footer-social-icons",
          "allowed-widgets": "social-icons",
        },
        on: { updateBlob: (data) => _vm.saveBlob("footer-social-icons", data) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }